var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21767_204628)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.97363 0.492188V1.47889",
    stroke: "#00D3F2",
    strokeWidth: 0.493352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.94678 0.492188V1.47889",
    stroke: "#00D3F2",
    strokeWidth: 0.493352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68705 0.986328H1.23359C0.961115 0.986328 0.740234 1.20721 0.740234 1.47968V4.93314C0.740234 5.20561 0.961115 5.42649 1.23359 5.42649H4.68705C4.95952 5.42649 5.1804 5.20561 5.1804 4.93314V1.47968C5.1804 1.20721 4.95952 0.986328 4.68705 0.986328Z",
    stroke: "#00D3F2",
    strokeWidth: 0.493352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.740234 2.4668H5.1804",
    stroke: "#00D3F2",
    strokeWidth: 0.493352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21767_204628"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.92022,
    height: 5.92022,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.9be119e30373465ab189c4aa55d3811e.svg";
export { ForwardRef as ReactComponent };